// import globalMessages from './shared/globals';
// const supportedLocales = Object.keys(globalMessages);  // or define somewhere else....

export const splI18nDataWindowVarName = 'i18nData';  // the name of the window variable that contains the i18n data (set in django templates)

export const splLocaleWindowVarName = 'splJSLocale';  // the name of the window variable that contains the current locale (set in django templates)

export const vueI18nInstanceVarName = '$vueI18nInstance';  // the name of the window variable that contains the vue-i18n instance (set in setupI18n.js)

export const coreTranslationsWindowVarName = 'splCoreTranslations';  // the name of the window variable that contains the core translations (set in django templates)

export const defaultLocale = 'en-US';  // the default locale to use if none is specified or if the specified locale is not supported

export const defaultLocaleObject = new Intl.Locale(defaultLocale);  // the default locale object